import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";

const OTHER = "__other__";
const today = () => new Date().toLocaleDateString("en-CA");

export const CatchForm = ({ spots, fishList, defaultSpot, onAdd }) => {
  const empty = { species: "", weight: "", length: "", date: today(), spotId: defaultSpot || OTHER, place: "", bait: "", notes: "" };
  const [f, setF] = useState(empty);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const spot = spots.find((s) => s.id === f.spotId);
    onAdd({
      species: f.species.trim(),
      weight: f.weight ? parseFloat(f.weight) : null,
      length: f.length ? parseFloat(f.length) : null,
      date: f.date,
      spotId: spot?.id || null,
      place: spot ? spot.name : f.place.trim(),
      bait: f.bait.trim(),
      notes: f.notes.trim(),
    });
    toast.success("Prise ajoutée au carnet !");
    setF({ ...empty, spotId: f.spotId });
  };

  return (
    <form onSubmit={submit} data-testid="catch-form" className="rounded-3xl bg-white border border-emerald-900/10 p-6 space-y-3 self-start">
      <p className="font-display font-bold text-lg text-emerald-950">Nouvelle prise</p>
      <Input required list="fish-list" placeholder="Espèce (ex : Brochet)" value={f.species} onChange={set("species")} data-testid="catch-species" className="rounded-xl" />
      <datalist id="fish-list">{fishList.map((x) => <option key={x} value={x} />)}</datalist>
      <div className="grid grid-cols-2 gap-3">
        <Input type="number" step="0.01" min="0" placeholder="Poids (kg)" value={f.weight} onChange={set("weight")} data-testid="catch-weight" className="rounded-xl" />
        <Input type="number" step="1" min="0" placeholder="Taille (cm)" value={f.length} onChange={set("length")} data-testid="catch-length" className="rounded-xl" />
      </div>
      <Input required type="date" value={f.date} max={today()} onChange={set("date")} data-testid="catch-date" className="rounded-xl" />
      <Select value={f.spotId} onValueChange={(v) => setF({ ...f, spotId: v })}>
        <SelectTrigger data-testid="catch-spot" className="rounded-xl"><SelectValue placeholder="Spot" /></SelectTrigger>
        <SelectContent className="max-h-72">
          <SelectItem value={OTHER}>Autre lieu…</SelectItem>
          {spots.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {f.spotId === OTHER && (
        <Input placeholder="Nom du lieu" value={f.place} onChange={set("place")} data-testid="catch-place" className="rounded-xl" />
      )}
      <Input placeholder="Technique / appât (ex : leurre souple)" value={f.bait} onChange={set("bait")} data-testid="catch-bait" className="rounded-xl" />
      <Textarea rows={3} placeholder="Notes (météo, heure, remise à l'eau…)" value={f.notes} onChange={set("notes")} data-testid="catch-notes" className="rounded-xl" />
      <button type="submit" data-testid="catch-submit" className="w-full flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white font-semibold py-3 rounded-full transition-colors">
        <Plus className="w-5 h-5" /> Ajouter au carnet
      </button>
    </form>
  );
};
